.Dice {
  width: 1em;
  height: 1em;
  margin: auto;
  position: relative;
}
.Dice .ItemBreakdown {
  left: -6em;
  right: -6em;
  z-index: 110;
  position: absolute;
  display: none;
}
.Dice .Label {
  left: -1.5em;
  right: -1.5em;
  z-index: 110;
  text-align: center;
  position: absolute;
  opacity: 0;
  transform: translateY(0.1em);
  transition-duration: 0.1s;
  transition-property: transform, opacity;
  pointer-events: none;
}
.Dice .Label .Title {
  font-size: 1rem;
  line-height: 1rem;
  font-family: var(--editor-font);
}
.Dice .Label span {
  padding: 0em 0.2em;
  background-color: #111111;
}
.Dice[anchored=bottom] .Label {
  top: 1.25em;
}
.Dice[anchored=bottom] .ItemBreakdown {
  top: 1.25em;
}
.Dice[anchored=top] .Label {
  bottom: 1.25em;
}
.Dice[anchored=top] .ItemBreakdown {
  bottom: 1.25em;
}
.Dice[index="0"] {
  grid-area: a;
}
.Dice[index="1"] {
  grid-area: b;
}
.Dice[index="2"] {
  grid-area: c;
}
.Dice[index="3"] {
  grid-area: d;
}
.Dice[index="4"] {
  grid-area: e;
}
.Dice[index="5"] {
  grid-area: f;
}
.Dice[isPressed] .ItemBreakdown {
  display: block;
}
.Dice[isPressed] .Label {
  display: none;
}
.Dice:not([isPressed]):hover .Label {
  opacity: 1;
  transform: translateY(0em);
}
.Dice[isLabeled] .Label {
  opacity: 1;
  transform: translateY(0em);
}
.Dice[isAnimated] .DiceFace {
  animation-name: roll;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  transform-origin: center;
}
.Dice[isAnimated][isLabeled] .Label {
  opacity: 0;
  animation-name: fade-in;
  animation-delay: 1s;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}
.Dice[isHighlighted] .DiceFace {
  transform: scale(1.3);
  z-index: 100;
  outline-color: #111111;
  outline-width: 0.1em;
  outline-style: solid;
}
.Dice[isAnimated][isHighlighted] .DiceFace {
  animation-name: roll-and-scale-up;
}
.Dice.Null .DiceFace {
  background-color: transparent;
  border-style: dashed !important;
  box-shadow: none;
}
@keyframes roll {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1080deg);
  }
}
@keyframes roll-and-scale-up {
  0% {
    transform: scale(1.1) rotate(0deg);
  }
  100% {
    transform: scale(1.3) rotate(1080deg);
  }
}
